export default {
	title: 'Device List',
	actions: {
		add: 'Add',
		edit: 'Edit',
		delete: 'Delete',
		batchDelete: 'Batch Delete',
		save: 'Save',
		cancel: 'Cancel',
		confirm: 'Confirm'
	},
	messages: {
		deleteSuccess: 'Delete successful',
		actionSuccess: 'Operation successful',
		noDeviceSelected: 'Please select devices to configure',
		noWaveTypeSelected: 'Please select a waveform type',
		dataCollectSuccess: 'Data collection issued successfully',
		configSuccess: 'Configuration successful',
		settingSuccess: 'Setting successful'
	},
	labels: {
		deviceList: 'Device List',
		startStopRecord: 'Start-Stop Record',
		dilutionStrategy: 'Dilution Strategy',
		dataCollectIssuance: 'Data Collection Issuance',
		markConfig: 'Mark Configuration',
		diagnose: 'Diagnose',
		deviceSensorConfig: 'Device Sensor Configuration',
		alarmTag: 'Alarm Tag',
		runAlarmAlgorithm: 'Run Alarm Algorithm',
		notRunAlarmAlgorithm: 'Do Not Run Alarm Algorithm'
	},
	buttons: {
		dilutionStrategy: 'Dilution Strategy',
		dataCollectIssuance: 'Data Collection Issuance',
		add: 'Add',
		markConfig: 'Mark Configuration',
		batchDelete: 'Batch Delete',
		deviceMoveOrg: 'Device Move Record',
		diagnose: 'Diagnose',
		deviceSensorConfig: 'Device Sensor Configuration',
		startStopRecord: 'Start-Stop Record',
		edit: 'Edit',
		delete: 'Delete',
		cancel: 'Cancel',
		confirm: 'Confirm'
	},
	table: {
		deviceName: 'Device Name',
		deviceNumber: 'Device Number',
		projectNumber: 'Project Number',
		org: 'Organization',
		type: 'Type',
		status: 'Status',
		warnLevel: 'Warning Level',
		runAlarmAlgorithm: 'Run Alarm Algorithm',
		modelImage: 'Model Image',
		deviceImage: 'Device Image',
		action: 'Action',
		oldOrgName: 'Old Organization',
		newOrgName: 'New Organization',
		moveDate: 'Move Date',
		operatorName: 'Operator'
	},
	form: {
		placeholder: {
			deviceNumber: 'Device Number',
			deviceName: 'Device Name',
			org: 'Organization Name',
			projectNumber: 'Project Number',
			type: 'Type Name',
			status: 'Status'
		},
		add: 'Add',
		update: 'Edit',
		cancel: 'Cancel',
		confirm: 'Confirm'
	},
	dialog: {
		dilutionStrategy: 'Dilution Strategy',
		dataCollectIssuance: 'Data Collection Issuance',
		shortWaveform: 'Short Waveform',
		longWaveform: 'Long Waveform',
		quarter: 'Quarter',
		halfYear: 'Half Year',
		year: 'Year',
		markConfig: 'Mark Configuration',
		deviceMoveOrg: 'Device Move Record',
		alarmTagRequired: 'Alarm tag is required',
		closeLongWaveform: 'Disable Long Waveform',
		openLongWaveform: 'Enable Long Waveform',
		closeLongWaveformConfirm: 'This will affect the "long waveform" storage configuration of ALL devices (long waveforms will no longer be saved). High/low frequency waveforms are not affected. Continue?',
		openLongWaveformConfirm: 'This will affect the "long waveform" storage configuration of ALL devices (long waveform saving will be restored). High/low frequency waveforms are not affected. Continue?',
		setCjpzSuccess: 'Setting succeeded'
	},
	config: {
		gridLayout: 'Grid Layout',
		deviceName: 'Device Name',
		deviceNumber: 'Device Number',
		project: 'Project',
		status: 'Status',
		deviceType: 'Device Type',
		diagnosticToolType: 'Diagnostic Tool Type',
		org: 'Organization',
		deviceImage: 'Device Image',
		deviceModelImage: 'Device Model Image',
		sort: 'Sort',
		pointName: 'Point Name',
		startStopSpeed: 'Start-Stop Speed Value',
		startStopAcc: 'Start-Stop Acceleration Value',
		abnormalTemp: 'Abnormal Temperature Value',
		abnormalSpeed: 'Abnormal Speed Value',
		accThreshold: 'Acceleration Threshold',
		speedThreshold: 'Speed Threshold',
		tempThreshold: 'Temperature Threshold',
		longWaveformCollect: 'Long Waveform Collection',
		label1: 'Label 1',
		nameRequired: 'Required field cannot be empty',
		orgPlaceholder: 'Organization (Diagnosis)'
	},
	index: {
		deviceList: 'Device List',
		startStopRecord: 'Start-Stop Record'
	}
}
